function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from 'react';
import "../../styling/components/common/DragAndDrop.css";
var dragCounter = 0;

var DragAndDrop = function DragAndDrop(props) {
  var handleFileDrop = props.handleFileDrop;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isDragging = _useState2[0],
      setIsDragging = _useState2[1]; // Use effects


  useEffect(function () {
    window.document.body.addEventListener('dragenter', handleDragEnter);
    window.document.body.addEventListener('dragover', handleDragOver, false);
    window.document.body.addEventListener('dragleave', handleDragLeave);
    window.document.body.addEventListener('drop', handleDrop, false);
    return function () {
      window.document.body.removeEventListener('dragenter', handleDragEnter);
      window.document.body.removeEventListener('dragover', handleDragOver, false);
      window.document.body.removeEventListener('dragleave', handleDragLeave);
      window.document.body.removeEventListener('drop', handleDrop, false);
    };
  }, []);

  var handleDragEnter = function handleDragEnter(e) {
    e.preventDefault();
    e.stopPropagation();
    dragCounter++;
    setIsDragging(true);
  };

  var handleDragOver = function handleDragOver(e) {
    e.preventDefault();
    e.stopPropagation();
  };

  var handleDragLeave = function handleDragLeave(e) {
    e.preventDefault();
    e.stopPropagation();
    dragCounter--;

    if (dragCounter === 0) {
      setIsDragging(false);
    }
  };

  var handleDrop = function handleDrop(e) {
    e.preventDefault();
    e.stopPropagation();
    dragCounter = 0;
    setIsDragging(false);
    handleFileDrop(e.dataTransfer.items[0].getAsFile());
  };

  return isDragging ? /*#__PURE__*/React.createElement("div", {
    className: "contacts-drag-n-drop"
  }, /*#__PURE__*/React.createElement("p", {
    className: "contacts-drag-n-drop-text"
  }, "Drop the file anywhere")) : null;
};

export default DragAndDrop;